import React, { Component } from "react";
import "antd/dist/antd.css";
import { Row, Col, Spin, Card, Tag } from "antd";
import { withRouter } from "react-router";
import { withAppContext } from "../../store/contextStore";
// import { Link } from 'react-router-dom';
import userLogo from "../../Images/user-logo.png";
import carrierTruck from "../../Images/carrier-truck.png";
import orderLogo from "../../Images/order-logo.png";
import orderStatus from "../../Images/order-status.png";
import AppConfigs from "../../Config/AppConfig";
import { list } from "../../api/Apis";
import moment from "moment";

class AdminNotifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageLoadingStatus: false,
      notifications: {},
    };
  }

  componentDidMount = () => {
    this.setState({
      pageLoadingStatus: true,
    });
    this.getNotifications();
  };

  getNotifications = () => {
    let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
    let query = {
      relatedTo: orgDetails["id"],
    };
    list(AppConfigs["entityNames"]["notifications"], query).then((result) => {
      if (result.success) {
        let notifications = {};
        let notificationsData = result.data.sort((a, b) =>
          parseInt(a["createdAt"]) < parseInt(b["createdAt"]) ? 1 : -1
        );
        notificationsData.map((notification) => {
          let dayFormat =
            moment(notification["createdAt"]).format("dddd, DD MMMM") ===
            moment().format("dddd, DD MMMM")
              ? "Today"
              : moment(notification["createdAt"]).format("dddd, DD MMMM");
          if (dayFormat in notifications) {
            notifications[dayFormat].push(notification);
          } else {
            notifications[dayFormat] = [];
            notifications[dayFormat].push(notification);
          }
          return notification;
        });
        this.setState({
          notifications: notifications,
          pageLoadingStatus: false,
        });
      } else {
        this.setState({
          dataLoadingStatus: false,
        });
        console.log(result.errors);
      }
    });
  };

  openDeatilsPage = (recordType, recordId) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    if (userDetails.userProfile === "A"||userDetails.userProfile === "M") {
      if (recordType === "carrier") {
        this.props.history.push("/app/carriers/carrierdetails/" + recordId);
      } else if (
        (recordType === "customer" ||
        recordType === "request_for_products" ||
        recordType === "request_location") 
      ) {
        this.props.history.push("/app/customers/customerdetails/" + recordId);
      } else {
        this.props.history.push("/app/loads/loaddetails/" + recordId);
      }
    } else if (userDetails.userProfile === "CU") {
      this.props.history.push("/app/orders/orderdetails/" + recordId);
    } else if (userDetails.userProfile === "CA") {
      this.props.history.push("/carrier_app/myOrders/orderdetails/" + recordId);
    }

    // if (recordType === "order") {
    //   this.props.history.push("/app/loads/loaddetails/" + recordId);
    // } else if (recordType === "carrier") {
    //   this.props.history.push("/app/carriers/carrierdetails/" + recordId);
    // } else if (recordType === "customer") {
    //   this.props.history.push("/app/customers/customerdetails/" + recordId);
    // }
  };
  render() {
    return (
      <div className="content-outer">
        <div className="content">
          <Spin spinning={this.state.pageLoadingStatus}>
            <Row>
              <Col xs={24} sm={24} md={24} lg={24}>
                <h1 className="headings">Notifications</h1>
                {Object.keys(this.state.notifications).map((day) => (
                  <div style={{ margin: "10px" }} key={day}>
                    <Col lg={24} md={24} sm={24} xs={24}>
                      <p style={{ color: "black", marginTop: "2%" }}>{day}</p>
                      <div className="site-card-border-less-wrapper">
                        <Card
                          style={{
                            backgroundColor: "#F8F8F8",
                            borderRadius: "10px",
                          }}
                        >
                          {this.state.notifications[day].map((data) => (
                            <Row
                              style={{
                                borderBottom: "1px solid lightgray",
                                cursor: "pointer",
                                marginTop: "1%",
                                backgroundColor: data["isActive"]
                                  ? "#FFF"
                                  : "rgb(248, 248, 248)",
                              }}
                              key={data["id"] + "_Row"}
                              onClick={() => {
                                this.openDeatilsPage(
                                  data["recordType"],
                                  data["recordId"]
                                );
                              }}
                            >
                              {(data["recordType"] === "order" ||
                                data["recordType"] === "order_assign") && (
                                <div>
                                  <Col lg={1} md={1} sm={24} xs={24}>
                                    <div
                                      style={{
                                        backgroundColor: "#FFF",
                                        width: "60px",
                                        height: "60px",
                                      }}
                                    >
                                      {data["isNew"] ? (
                                        <img
                                          src={orderLogo}
                                          style={{
                                            width: "25px",
                                            margin: "17px",
                                          }}
                                          alt="logo"
                                        />
                                      ) : (
                                        <img
                                          src={orderStatus}
                                          style={{
                                            width: "25px",
                                            margin: "17px",
                                          }}
                                          alt="logo"
                                        />
                                      )}
                                    </div>
                                  </Col>
                                  <Col lg={20} md={20} sm={24} xs={24}>
                                    {data["isNew"] ? (
                                      <div style={{ marginLeft: "10px" }}>
                                        <h4 style={{ color: "black" }}>
                                          {"New Order #" + data["orderId"]}
                                        </h4>
                                        {/* <p><span style={{ color: 'black' }}>{data["createdBy"]}</span> placed new order <span style={{ color: 'black' }}>#123234</span></p> */}
                                        <p>
                                          <span style={{ color: "black" }}>
                                            {data["customerName"]
                                              ? data["customerName"] +
                                                ", " +
                                                data["companyName"]
                                              : data["createdBy"]}
                                          </span>{" "}
                                          just placed a new order{" "}
                                          <span style={{ color: "black" }}>
                                            {"#" + data["orderId"]}
                                          </span>
                                        </p>
                                      </div>
                                    ) : (
                                      <div style={{ marginLeft: "10px" }}>
                                        <h4 style={{ color: "black" }}>
                                          Order status changed
                                        </h4>
                                        <p>
                                          <span style={{ color: "black" }}>
                                            {"Order #" + data["orderId"]}
                                          </span>{" "}
                                          status changed to &nbsp;
                                          {/* <Tag color="orange" style={{ borderRadius: '10px' }}>IN PROGRESS</Tag> */}
                                          <Tag
                                            color={
                                              AppConfigs["STATUS_COLORS"][
                                                data["orderNewStatus"]
                                              ]
                                            }
                                            style={{
                                              color: "black",
                                              height: "27px",
                                              fontSize: "12px",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {
                                              AppConfigs["DISPLAY_LEAD_STATUS"][
                                                "admin"
                                              ][data["orderNewStatus"]]
                                            }
                                          </Tag>
                                        </p>
                                      </div>
                                    )}
                                  </Col>
                                  <Col lg={3} md={3} sm={24} xs={24}>
                                    <span style={{ float: "right" }}>
                                      {moment(data["createdAt"]).format(
                                        "hh:mm A"
                                      )}
                                    </span>
                                  </Col>
                                </div>
                              )}
                              {(data["recordType"] === "customer" ||
                                data["recordType"] === "carrier") &&
                                data["isNew"] && (
                                  <div>
                                    <Col lg={1} md={1} sm={24} xs={24}>
                                      <div
                                        style={{
                                          backgroundColor: "#FFF",
                                          width: "60px",
                                          height: "60px",
                                        }}
                                      >
                                        {data["recordType"] === "customer" ? (
                                          <img
                                            src={userLogo}
                                            style={{
                                              width: "25px",
                                              margin: "17px",
                                            }}
                                            alt="logo"
                                          />
                                        ) : (
                                          <img
                                            src={carrierTruck}
                                            style={{
                                              width: "33px",
                                              margin: "17px",
                                            }}
                                            alt="logo"
                                          />
                                        )}
                                      </div>
                                    </Col>
                                    <Col lg={20} md={20} sm={24} xs={24}>
                                      <div style={{ marginLeft: "10px" }}>
                                        <h4 style={{ color: "black" }}>
                                          {"New " +
                                            data["recordType"] +
                                            " signed up"}
                                        </h4>
                                        {/* <p><span style={{ color: 'black' }}>{data["createdBy"]}</span> created new account</p> */}
                                        <p>
                                          <span style={{ color: "black" }}>
                                            {data["customerName"]
                                              ? data["customerName"] +
                                                ", " +
                                                data["companyName"]
                                              : data["createdBy"]}
                                          </span>{" "}
                                          {"just signed up as a new " +
                                            data["recordType"]}
                                        </p>
                                      </div>
                                    </Col>
                                    <Col lg={3} md={3} sm={24} xs={24}>
                                      <span style={{ float: "right" }}>
                                        {moment(data["createdAt"]).format(
                                          "hh:mm A"
                                        )}
                                      </span>
                                    </Col>
                                  </div>
                                )}
                              {data["recordType"] ===
                                "request_for_products" && (
                                <div>
                                  <Col lg={1} md={1} sm={24} xs={24}>
                                    <div
                                      style={{
                                        backgroundColor: "#FFF",
                                        width: "50px",
                                        height: "50px",
                                      }}
                                    >
                                      {data["isNew"] === true ? (
                                        <img
                                          src={orderLogo}
                                          style={{
                                            width: "20px",
                                            margin: "20px",
                                          }}
                                          alt="logo"
                                        />
                                      ) : (
                                        <img
                                          src={orderStatus}
                                          style={{
                                            width: "17px",
                                            margin: "17px",
                                          }}
                                          alt="logo"
                                        />
                                      )}
                                    </div>
                                  </Col>
                                  <Col lg={20} md={20} sm={24} xs={24}>
                                    <div style={{ marginLeft: "10px" }}>
                                      <h4 style={{ color: "black" }}>
                                        Requesting products
                                      </h4>
                                      <p>
                                        <span style={{ color: "black" }}>
                                          {data["customerName"]
                                            ? data["customerName"] +
                                              " requested products on:" +
                                              data.customerProducts?.map(
                                                (c) => " " + c.productName
                                              )
                                            : ""}
                                        </span>
                                      </p>
                                    </div>
                                  </Col>
                                  <Col lg={3} md={3} sm={24} xs={24}>
                                    <span style={{ float: "right" }}>
                                      {moment(data["createdAt"]).format(
                                        "hh:mm A"
                                      )}
                                    </span>
                                  </Col>
                                </div>
                              )}
                              {data["recordType"] === "request_location" && (
                                <div>
                                  <Col lg={1} md={1} sm={24} xs={24}>
                                    <div
                                      style={{
                                        backgroundColor: "#FFF",
                                        width: "50px",
                                        height: "50px",
                                      }}
                                    >
                                      {data["isNew"] === true ? (
                                        <img
                                          src={orderLogo}
                                          style={{
                                            width: "20px",
                                            margin: "20px",
                                          }}
                                          alt="logo"
                                        />
                                      ) : (
                                        <img
                                          src={orderStatus}
                                          style={{
                                            width: "17px",
                                            margin: "17px",
                                          }}
                                          alt="logo"
                                        />
                                      )}
                                    </div>
                                  </Col>
                                  <Col lg={20} md={20} sm={24} xs={24}>
                                    <div style={{ marginLeft: "10px" }}>
                                      <h4 style={{ color: "black" }}>
                                        Requesting location
                                      </h4>
                                      <p>
                                        <span style={{ color: "black" }}>
                                          Bulk customer requested for new
                                          location
                                        </span>
                                      </p>
                                    </div>
                                  </Col>
                                  <Col lg={3} md={3} sm={24} xs={24}>
                                    <span style={{ float: "right" }}>
                                      {moment(data["createdAt"]).format(
                                        "hh:mm A"
                                      )}
                                    </span>
                                  </Col>
                                </div>
                              )}
                            </Row>
                          ))}
                        </Card>
                      </div>
                    </Col>
                  </div>
                ))}
              </Col>
            </Row>
          </Spin>
        </div>
      </div>
    );
  }
}
export default withAppContext(withRouter(AdminNotifications));
